import { Component, inject } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { EnaioCertificateService } from '../../services/enaio-certificate.service';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';

@Component({
  selector: 'app-class-analyses',
  templateUrl: './class-analyses.component.html',
  styleUrls: ['./class-analyses.component.scss']
})
export class ClassAnalysesComponent extends ComponentView {

    service = inject(EnaioCertificateService);

    neededParams: ObjectOfSimpleDataTypes = { id: "number" };
    id: number;

    override async initParams(): Promise<boolean> {
        await this.service.updateNavigationClassRegister(this.id, [{ label: "Auswertungen", routerLink: ["/enaio-certificates", "class-registers", "analyses", this.id] }]);
        return true;
    }

}
